import styled from '@emotion/styled';
import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { FaBuilding, FaEnvelope, FaMapMarkerAlt, FaPhone, FaSave } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { AssetManagerType } from '../../../../redux/userStore/reducer';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import { addAssetManager } from '../../../dashboard/network';

const FormShell = styled.div`
  .form-context {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    padding: 14px;
    margin-bottom: 16px;
    background:
      linear-gradient(135deg, rgba(255, 79, 31, 0.1), transparent 44%),
      ${PRIMARY};
    color: #fff7e8;
  }

  .form-context span {
    color: ${YELLOW};
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .form-context h3 {
    margin: 5px 0;
    color: #fff7e8;
    font-family: Poppins-B;
    font-size: 22px;
  }

  .form-context p {
    margin: 0;
    color: rgba(255, 247, 232, 0.72);
  }

  .field-grid {
    display: grid;
    gap: 10px;
  }

  .ant-input-affix-wrapper {
    min-height: 42px;
    border-color: var(--mt-border);
    border-radius: 8px;
    background: var(--mt-surface);
    color: var(--mt-text);
  }

  .ant-input-affix-wrapper input,
  .ant-input {
    background: transparent;
    color: var(--mt-text);
  }

  .field-icon {
    color: ${YELLOW};
  }

  .submit-row {
    display: flex;
    justify-content: flex-end;
    margin-top: 18px;
  }

  .submit-button {
    min-width: 180px;
    height: 42px;
    border: 0;
    border-radius: 999px;
    background: linear-gradient(135deg, ${ORANGE}, ${YELLOW});
    color: #07141c;
    font-family: Poppins-B;
  }
`;

export const AssetForm = ({
  setShowDrawer,
  getNewAsset,
}: {
  setShowDrawer: (b: boolean) => void;
  getNewAsset: (part: AssetManagerType) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const connectedUser = new ConnectedUserEntity(
    useSelector((state: any) => state.userReducer).user,
  );

  return (
    <FormShell>
      <div className='form-context'>
        <span>Nouveau client</span>
        <h3>Créer un client MoranjETrade</h3>
        <p>Renseignez les informations de contact de la société cliente.</p>
      </div>
      <Form
        layout='vertical'
        form={form}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        onFinish={async (data) => {
          setIsLoading(true);
          data.code = '1234';
          await addAssetManager(connectedUser.id, data).then(
            ({ statusCode, data }) => {
              if (statusCode.toString()[0] === '2') {
                notification.success({
                  message: 'Client créé',
                  description: 'Votre client a été créé avec succès',
                });
                getNewAsset(data);
                setShowDrawer(false);
              } else {
                notification.error({
                  message: 'Erreur',
                  description: data.message,
                });
              }
              setIsLoading(false);
            },
          );
        }}
      >
        <div className='field-grid'>
          <Form.Item
            label='Nom du client'
            name='nom'
            hasFeedback
            rules={[
              {
                required: true,
                message: 'Entrez le nom du client',
              },
            ]}
          >
            <Input prefix={<FaBuilding className='field-icon' />} placeholder='Ex. MORANJ Securities' />
          </Form.Item>
          <Form.Item
            label='Email du client'
            name='email'
            hasFeedback
            rules={[
              {
                required: true,
                message: "Entrez l'email du client",
              },
              {
                type: 'email',
                message: 'Entrez une adresse email valide',
              },
            ]}
          >
            <Input prefix={<FaEnvelope className='field-icon' />} placeholder='contact@societe.com' />
          </Form.Item>
          <Form.Item
            label='Adresse du client'
            name='adresse'
            hasFeedback
            rules={[
              {
                required: true,
                message: "Entrez l'adresse du client",
              },
            ]}
          >
            <Input prefix={<FaMapMarkerAlt className='field-icon' />} placeholder='Ville, quartier, immeuble' />
          </Form.Item>
          <Form.Item
            label='Contact du client'
            name='contact'
            hasFeedback
            rules={[
              {
                required: true,
                message: 'Entrez le numéro de téléphone du client',
              },
            ]}
          >
            <Input prefix={<FaPhone className='field-icon' />} placeholder='Numéro de téléphone' />
          </Form.Item>
        </div>
        <Form.Item className='submit-row'>
          <Button
            htmlType='submit'
            loading={isLoading}
            className='submit-button'
            icon={<FaSave />}
          >
            Créer le client
          </Button>
        </Form.Item>
      </Form>
    </FormShell>
  );
};
